module.exports = __webpack_public_path__ + "src/app/_content/MINIFonts/fontello.svg?af94dd9ab88b465c0cf2ab87dc1dfaa8";